/* Adler Profishop – dauerhafter Link "Cookie-Einstellungen" in der Fusszeile (LS16)
   Oeffnet die Einstellungen des Shopify-Cookie-Banners erneut, damit eine Auswahl
   jederzeit geaendert oder eine Einwilligung widerrufen werden kann. */
(function () {
  'use strict';
  var FALLBACK = '/policies/privacy-policy';

  function showBanner() {
    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') { banner.showPreferences(); return true; }
    return false;
  }
  function openSettings(event) {
    event.preventDefault();
    if (showBanner()) return;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error || !showBanner()) window.location.href = FALLBACK;
      });
      return;
    }
    window.location.href = FALLBACK;
  }
  function mount() {
    var bar = document.querySelector('.footer-bottom > span:last-child');
    if (!bar || bar.querySelector('[data-adler-cookie-settings]')) return;
    var link = document.createElement('a');
    link.href = '#cookie-einstellungen';
    link.textContent = 'Cookie-Einstellungen';
    link.setAttribute('data-adler-cookie-settings', '');
    link.addEventListener('click', openSettings);
    bar.appendChild(link);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
